/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Movement_Received_By_LabelInputs */



/**
* | output |
* | --- |
* | "Received by" |
*
* @param {Promo_Movement_Received_By_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_movement_received_by_label = /** @type {((inputs?: Promo_Movement_Received_By_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Movement_Received_By_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reçu par")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recibido por")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Recebido por")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricevuto da")
	return /** @type {LocalizedString} */ ("Received by")
});